module.exports = __webpack_public_path__ + "static/img/50.6023571.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/50.png
// module id = 4weJ
// module chunks = 6